import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  style: {"margin":"0 auto","width":"100%","display":"inline-flex","flex-direction":"column","padding":"24px 24px 0 24px","overflow-y":"scroll"},
  class: "flex-grow"
}
const _hoisted_2 = { class: "incredi-scroll-bar-page min-w-[814px] flex-grow mb-[24px]" }

import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { IncrediCard } from 'incredi-ui';
import { Routes } from '@/router/router.const';

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { convertBaseTimeToSSMMHH } from '@/views/dashboard/dashboard.charts.utils';
import { useWorkloadsDataProvider, useWorkloadsFilterDataProvider } from '@/views/workloads/workloads.helpers';
import dashboardOverview from './components/dashboard-overview.vue';
import { useDashboardFilters } from './components/dashboard-filter-bar/dashboard-filter.provider';
import DashboardHeader from './components/dashboard-header.vue';
import DashboardOverviewTitle from './components/dashboard-overview-title.vue';
import DashboardOverviewTotalBuilds from './components/dashboard-overview-total-builds.vue';
import DashboardOverviewAvgBuilds from './components/dashboard-overview-avg-builds.vue';
import { useDashboard, useDashboardProvider, useFilteredDashboardMetadata } from './dashboard.provider';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {

const { t } = useI18n();
const { hasBuildCacheInLicense } = useWorkloadsDataProvider();
useWorkloadsFilterDataProvider();
useDashboardProvider();
const route = useRoute();
const dashboardFilters = useDashboardFilters();
const pageKey = ref(0);

const dashboard = useDashboard();
const overview = computed(() => {
  switch (route.name) {
    case Routes.DashboardGridUtilization:
      return dashboard.gql.gridUtilizationQuery.result.value?.systemUtilization?.overview;
    case Routes.DashboardWorkloads:
      return dashboard.gql.workloadsQuery.result.value?.workloads?.overview;
    default:
      return null;
  }
});
useFilteredDashboardMetadata({
  fetchPolicy: 'network-only',
});
const isDashboardOverviewHidden = computed(() => !overview.value?.totalWorkloads && !overview.value?.totalWorkloadsDuration);

watch(
  () => dashboardFilters,
  () => {
    pageKey.value += 1;
  },
  {
    deep: true,
  },
);

const totalWithBuildCache = computed(() => overview.value?.totalWorkloadsWithBuildCache || 0);
const totalWithoutBuildCache = computed(() => overview.value?.totalWorkloadsWithoutBuildCache || 0);
const avgWithBuildCache = computed(() => overview.value?.avgWorkloadsWithBuildCacheDuration || 0);
const avgWithoutBuildCache = computed(() => overview.value?.avgWorkloadsWithoutBuildCacheDuration || 0);
const avgOverall = computed(() => overview.value?.avgWorkloadsDuration || 0);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(IbxScopedCss, {
    key: pageKey.value,
    class: "wide-scroller",
    style: {"margin":"0 auto","width":"100%","display":"inline-flex","flex-direction":"column"}
  }, {
    default: _withCtx(() => [
      _createVNode(DashboardHeader),
      _createElementVNode("div", _hoisted_1, [
        (!_unref(isDashboardOverviewHidden))
          ? (_openBlock(), _createBlock(_unref(IncrediCard), {
              key: 0,
              class: _normalizeClass(["min-w-[814px] max-w-[1624px] w-full mx-auto !shadow-none border border-Border/border_natural", {
          'mb-[40px]': !_unref(isDashboardOverviewHidden),
        }])
            }, {
              default: _withCtx(() => [
                _createVNode(dashboardOverview, { "container-class": "grid-cols-3" }, {
                  default: _withCtx(() => [
                    _createVNode(DashboardOverviewTotalBuilds, {
                      totalWorkloads: _unref(overview)?.totalWorkloads || 0,
                      totalWithBuildCache: _unref(totalWithBuildCache),
                      totalWithoutBuildCache: _unref(totalWithoutBuildCache),
                      "has-build-cache-in-license": _unref(hasBuildCacheInLicense)
                    }, null, 8, ["totalWorkloads", "totalWithBuildCache", "totalWithoutBuildCache", "has-build-cache-in-license"]),
                    _createVNode(DashboardOverviewAvgBuilds, {
                      "avg-overall": _unref(avgOverall),
                      "avg-with-build-cache": _unref(avgWithBuildCache),
                      "avg-without-build-cache": _unref(avgWithoutBuildCache),
                      "has-build-cache-in-license": _unref(hasBuildCacheInLicense)
                    }, null, 8, ["avg-overall", "avg-with-build-cache", "avg-without-build-cache", "has-build-cache-in-license"]),
                    _createVNode(DashboardOverviewTitle, {
                      title: _unref(t)('dashboard.statusBar.totalBuildDuration'),
                      value: _unref(convertBaseTimeToSSMMHH)(_unref(overview)?.totalWorkloadsDuration, 'seconds', true)
                    }, null, 8, ["title", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})